import * as Yup from 'yup';
import messages from './paymentForm.messages';
import { PAYMENT_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';

export const defaultValues = ({ firstName, lastName, email }) => ({
  [FIELDS.firstName]: firstName || '',
  [FIELDS.lastName]: lastName || '',
  [FIELDS.email]: email || '',
});

export const PaymentSchema = Yup.object().shape({
  [FIELDS.firstName]: Yup.string().required(messages.fieldRequired),
  [FIELDS.lastName]: Yup.string().required(messages.fieldRequired),
  [FIELDS.email]: Yup.string()
    .email(messages.incorrectEmailFormat)
    .required(messages.fieldRequired),
});
